import { render, staticRenderFns } from "./BenefitBox.vue?vue&type=template&id=d4f525ac&scoped=true&"
import script from "./BenefitBox.vue?vue&type=script&lang=js&"
export * from "./BenefitBox.vue?vue&type=script&lang=js&"
import style0 from "./BenefitBox.vue?vue&type=style&index=0&id=d4f525ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f525ac",
  null
  
)

export default component.exports